module.exports = __webpack_public_path__ + "static/assets/acc6c29b5eee67bc6b2aa85854d9bb3a.svg";